import { Box, BoxProps } from '@mui/material'
import { ReactNode, forwardRef } from 'react'
import { Helmet } from 'react-helmet-async'

export interface PageProps extends BoxProps {
  children: ReactNode
  meta?: ReactNode
  title: string
}
const Page = forwardRef<HTMLDivElement, PageProps>(
  ({ children, title = '', meta, ...other }, ref) => (
    <>
      <Helmet>
        <title>{title}</title>
        {meta}
      </Helmet>

      <Box ref={ref} {...other}>
        {children}
      </Box>
    </>
  ),
)

export default Page
